import type { ContentPage } from "@/lib/content/types";

// CRM › Salesforce Automation › Cadences (leaf).
export const cadences: ContentPage = {
  slug: "salesforce-automation/cadences",
  template: "hrmsFeature",
  seo: {
    title: "Sales Cadence Software - Automate Outreach Sequences | GetBiz CRM",
    description:
      "Build multi-step, multi-channel outreach with GetBiz CRM sales cadence software. Automate email, calls and follow-ups to engage prospects and book more meetings.",
    keywords: [
      "sales cadence software",
      "sales sequences software",
      "sales engagement platform",
      "outreach automation",
      "follow-up automation",
      "cadence tool",
      "CRM cadences",
    ],
    ogImage: "/assets/data/seoimages/cadences.webp",
  },
  leaf: {
    hero: {
      caption: "Cadences",
      title: "Automate Outreach That Actually Gets Replies",
      description:
        "Design multi-step, multi-channel sequences of emails, calls and tasks that run automatically — so every prospect gets consistent, timely follow-up without manual effort.",
      h1: "caption",
    },
    split: {
      title: "Consistent Follow-up, Fully Automated",
      bullets: [
        { title: "Multi-step Sequences", description: "Chain emails, calls and tasks over days or weeks." },
        { title: "Multi-channel", description: "Reach prospects by email, phone and SMS in one flow." },
        { title: "Auto-enrolment", description: "Add leads and contacts to cadences with a rule or a click." },
        { title: "Engagement Tracking", description: "See opens, replies and steps completed for every prospect." },
      ],
      image: "/assets/images/img/product/crm/sales-cadence-image.webp",
      imageAlt: "GetBiz CRM sales cadence software",
    },
    cardsHeading: {
      title: "Works With the Rest of Salesforce Automation",
      description:
        "Cadences connect to every other part of your GetBiz CRM sales workflow.",
    },
    cards: [
      { title: "Lead Management", href: "/crm-software/salesforce-automation/lead-management/", description: "Auto-enrol new leads into the right outreach sequence.", image: "/assets/images/img/product/crm/lead-managemnet-crm.webp", imageAlt: "CRM lead management" },
      { title: "Contact Management", href: "/crm-software/salesforce-automation/contact-management/", description: "Run cadences against any segment of your contacts.", image: "/assets/images/img/product/crm/contact-management-image.webp", imageAlt: "CRM contact management" },
      { title: "Deal Management", href: "/crm-software/salesforce-automation/deal-management/", description: "Keep deals moving with automated follow-up sequences.", image: "/assets/images/img/product/crm/deal-management-image-Photoroom.webp", imageAlt: "CRM deal management" },
      { title: "Workflow Management", href: "/crm-software/salesforce-automation/workflow-management/", description: "Start and stop cadences automatically with workflow rules.", image: "/assets/images/img/product/crm/workflow-image.webp", imageAlt: "CRM workflow management" },
    ],
    testimonials: {
      title: "Book more meetings with GetBiz CRM",
      description: "See why sales teams automate outreach with GetBiz.",
    },
    bookDemoTitle: "Put your outreach on autopilot.",
    relatedBlogs: "slug",
    relatedBlogsKeyword: "sales-cadence-guide, sales-follow-up-sequences",
    metaKey: "cadences",
  },
  sections: [],
};
